import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { footBallMessages } from './footballBall'
import { basketBallMessages } from './basketBall'

Vue.use(VueI18n)

let i18n = new VueI18n({
  locale: '1_1',
  fallbackLocale: '1_1',
  formatFallbackMessages: true,
  missing: (locale, key) => {
    console.log(`translation missing: locale=${locale}, key=${key}`)
  },
  messages: {
    ...footBallMessages,
    ...basketBallMessages
  }
})
export default i18n
export const defaultLanguage = '1'

export function switchLang (sportID, lang) {
  let newLocal = sportID + '_' + lang

  if (i18n.locale !== newLocal) {
    i18n.locale = newLocal
    i18n.fallbackLocale = sportID + '_' + defaultLanguage
    console.log(`change to language: sportID=${sportID}, lang=${lang}`)
  }
}
